import { render, staticRenderFns } from "./App.vue?vue&type=template&id=0c8d5702&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style1 from "./App.vue?vue&type=style&index=1&id=0c8d5702&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8d5702",
  null
  
)

export default component.exports